import Loader from 'components/atoms/loader';
import { ClientDataTypes } from 'interfaces/robot_dashboard';
import React, { useEffect, useState } from 'react';
import { fetchRobotDashboardUsers } from 'services/actions/robot_dashboard_actions';
import DataTable from 'react-data-table-component';
import { datatableColumns, datatableData } from './datatable_list';

const RobotDashboardUsers = () => {
  const [usersList, setUsersList] = useState<Array<ClientDataTypes> | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    fetchRobotDashboardUsers(setUsersList, setLoading, setLoaded, setError);
  }, []);

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
        fontSize: '14px',
        fontWeight: 'bold',
      },
    },
    cells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  return (
    <div className="container-fluid big-resolutions p-4">
      {loading && <Loader />}
      {error && <div>Erro ao Carregar Dados</div>}
      {loaded && (
        <div className="row">
          <div className="col-12">
            <h4>Usuários</h4>
            {usersList && (
              <DataTable
                columns={datatableColumns()}
                data={datatableData(usersList)}
                customStyles={customStyles}
                noDataComponent={<div className="p-5">Nenhum usuário com venda ativa.</div>}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RobotDashboardUsers;
